import { getCallMetrics } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useCallMetric = (params: DashboardFilters, isCompanyAdmin?: boolean) => {
  const enabled = isCompanyAdmin || !!params.company_name;

  const {
    data: callMetricData,
    error,
    isPending,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.CALL_METRICS(params),
    queryFn: () => getCallMetrics(params),
    enabled,
  });

  // `isPending` stays true forever on a disabled query, so a caller distinguishing
  // "still arriving" from "will never arrive" needs `isLoading`.
  return { callMetricData, error, isPending, isLoading, refetch };
};
